module.exports = __webpack_public_path__ + "img/icon(8).9d858644.png";